// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"0f1d61bf","98":"699ceab4","122":"639eb0db","256":"5f6601d3","389":"f0e2d1cc","405":"9371df84","656":"e45ebd02","897":"aade2cd5","938":"97981a32","968":"53689328"}[chunkId] + ".chunk.js";
};